export default __webpack_public_path__ + "static/media/treyd_square_logo_black.f55ebc57.svg";